export default __webpack_public_path__ + "media/zurb/img/events/wired/rcs/rcs-thumb-2a627e9d9aa2f6d8c7468b817b376138.png";